import { DataGrid } from "@mui/x-data-grid";
import { Box, Card, Skeleton, Typography } from "@mui/material";
import { format } from "date-fns";

const columns = [
  {
    field: "searchedAt",
    headerName: "When",
    width: 170,
    valueGetter: (params) =>
      params.row.searchedAt
        ? format(new Date(params.row.searchedAt), "dd MMM yyyy HH:mm")
        : "—",
  },
  {
    field: "query",
    headerName: "What they typed",
    flex: 1.2,
    minWidth: 220,
  },
  {
    field: "filterSummary",
    headerName: "Filters applied",
    flex: 1.6,
    minWidth: 260,
  },
  {
    field: "state",
    headerName: "State",
    width: 90,
    valueGetter: (params) =>
      params.row.state ? String(params.row.state).toUpperCase() : "—",
  },
];

export default function AiSearchLogListing({
  isLoading,
  error,
  data,
  rowCountState,
  paginationModel,
  setPaginationModel,
}) {
  if (isLoading) {
    return (
      <Skeleton
        sx={{
          transform: "scale(1, 1.0)",
          transformOrigin: "0% 0%",
        }}
        width="100%"
        height="600px"
      />
    );
  }

  if (error) {
    return (
      <Typography variant="body1">
        Something went wrong loading search logs.
      </Typography>
    );
  }

  return (
    <Card sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Recent AI searches
      </Typography>
      <Box sx={{ height: 600, width: "100%" }}>
        <DataGrid
          rows={data?.searches || []}
          columns={columns}
          rowCount={rowCountState}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          loading={isLoading}
          paginationMode="server"
          getRowId={(row) => row.id}
          getRowHeight={() => "auto"}
          sx={{
            "& .MuiDataGrid-cell": {
              py: 1.25,
              whiteSpace: "normal",
              lineHeight: 1.4,
            },
          }}
        />
      </Box>
    </Card>
  );
}
